import { render, staticRenderFns } from "./warrantyStatement.vue?vue&type=template&id=5376d23c&scoped=true"
import script from "./warrantyStatement.vue?vue&type=script&lang=js"
export * from "./warrantyStatement.vue?vue&type=script&lang=js"
import style0 from "./warrantyStatement.vue?vue&type=style&index=0&id=5376d23c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376d23c",
  null
  
)

export default component.exports